/* New Geoloc */
function newGeoloc() {

    if(!current_market || typeof current_market === 'undefined' || !document.querySelector(`.select-country-link[data-country="${current_market}"]`)) return;
    const curr_el = document.querySelector(`.select-country-link[data-country="${current_market}"]`),
        curr_tab = curr_el.closest('.TabPanel');
    curr_el.classList.add('select-country-link--active');
    if(curr_tab && curr_tab.id && document.querySelector(`country-drawer .Custom__TabList-Item[aria-controls="${curr_tab.id}"]`)) {
        curr_tab.setAttribute('aria-hidden',false);
        curr_tab.dataset.active = 'true';
    }
    const tab_trigger = document.querySelector(`country-drawer .Custom__TabList-Item[aria-controls="${curr_tab.id}"]`);
    if(tab_trigger) {
        tab_trigger.setAttribute('aria-selected',true);
        tab_trigger.dataset.active = 'true';
    }

    document.querySelectorAll('.select-country-link').forEach(el => el.addEventListener('click', newGetLinkAttr));
}

function newGetLinkAttr(event) {
    event.preventDefault();
    if(!document.querySelector('#FooterCountryForm') || !document.querySelector(`#FooterCountryForm .link[data-value="${event.target.dataset.country}"]`)) return;
    _cSc(document.querySelector(`#FooterCountryForm .link[data-value="${event.target.dataset.country}"]`));
}

window.addEventListener('DOMContentLoaded', newGeoloc);
/* New Geoloc */
